// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1lZIc","marginSpace":"footer_marginSpace__22avT","logoImg":"footer_logoImg__2w5GT","mobile":"footer_mobile__19DRB","social":"footer_social__GtHoN"};